import React from "react";
import { GALLERY } from "@/data/site";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-28 px-5 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center flex flex-col items-center">
          <SectionHeading
            eyebrow="Photo Gallery"
            title="Moments from our travelers' journeys"
            subtitle="A glimpse of the destinations, experiences and memories we help create."
            align="center"
          />
        </div>

        <Reveal>
          <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-4">
            {GALLERY.map((src, i) => (
              <div
                key={src}
                data-testid={`gallery-item-${i}`}
                className="masonry-item zoom-wrap rounded-2xl overflow-hidden shadow-md cursor-zoom-in"
              >
                <img
                  src={src}
                  alt={`Gallery ${i+1}`}
                  loading="lazy"
                  className="zoom-img w-full h-auto block"
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
